import { render } from "./VerifySlide.vue?vue&type=template&id=2270e8fc"
import script from "./VerifySlide.vue?vue&type=script&lang=js"
export * from "./VerifySlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4e85b6a685c6792d169835830baf5532/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__